import api from './api';

export async function getNotifications() {
  const { data } = await api.get('/api/notifications');
  return {
    rows: Array.isArray(data?.rows) ? data.rows : [],
    unreadCount: Number(data?.unreadCount) || 0,
  };
}

export async function markAsRead(id, isRead = true) {
  const { data } = await api.put(`/api/notifications/${encodeURIComponent(id)}/read`, { is_read: isRead });
  return data;
}

export async function markAllAsRead() {
  const { data } = await api.put('/api/notifications/read-all');
  return data;
}
